import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { DocsComponentName } from "../constant";
import { getExtensionSafe } from "../utils";

/**
 * 唤起通讯录
 * @param config
 * @returns
 */
export var evokeContactSelector = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(config) {
    var _config$padId, padId, _config$mobileMode, mobileMode, _config$isSelectMembe, isSelectMemberScene, _config$isSelectDeptS, isSelectDeptScene, _config$memberRoleIte, memberRoleItems, _config$selectedDisab, selectedDisableItems, _config$selectorTitle, selectorTitle, _config$isMultiSelect, isMultiSelect, _config$selectedItems, selectedItems, collaborateMemberOption, customizedMemberRoleOption, _config$requestHeader, requestHeaders, _config$isRootDeptSel, isRootDeptSelected, _config$limitedUnfold, limitedUnfoldLevelCount, _config$isMemberHidde, isMemberHidden, onSelectorShow, onSelectorClose, contactSelectorEntryConfig;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _config$padId = config.padId, padId = _config$padId === void 0 ? '' : _config$padId, _config$mobileMode = config.mobileMode, mobileMode = _config$mobileMode === void 0 ? false : _config$mobileMode, _config$isSelectMembe = config.isSelectMemberScene, isSelectMemberScene = _config$isSelectMembe === void 0 ? true : _config$isSelectMembe, _config$isSelectDeptS = config.isSelectDeptScene, isSelectDeptScene = _config$isSelectDeptS === void 0 ? false : _config$isSelectDeptS, _config$memberRoleIte = config.memberRoleItems, memberRoleItems = _config$memberRoleIte === void 0 ? [] : _config$memberRoleIte, _config$selectedDisab = config.selectedDisableItems, selectedDisableItems = _config$selectedDisab === void 0 ? [] : _config$selectedDisab, _config$selectorTitle = config.selectorTitle, selectorTitle = _config$selectorTitle === void 0 ? '' : _config$selectorTitle, _config$isMultiSelect = config.isMultiSelect, isMultiSelect = _config$isMultiSelect === void 0 ? true : _config$isMultiSelect, _config$selectedItems = config.selectedItems, selectedItems = _config$selectedItems === void 0 ? [] : _config$selectedItems, collaborateMemberOption = config.collaborateMemberOption, customizedMemberRoleOption = config.customizedMemberRoleOption, _config$requestHeader = config.requestHeaders, requestHeaders = _config$requestHeader === void 0 ? {} : _config$requestHeader, _config$isRootDeptSel = config.isRootDeptSelected, isRootDeptSelected = _config$isRootDeptSel === void 0 ? false : _config$isRootDeptSel, _config$limitedUnfold = config.limitedUnfoldLevelCount, limitedUnfoldLevelCount = _config$limitedUnfold === void 0 ? 0 : _config$limitedUnfold, _config$isMemberHidde = config.isMemberHidden, isMemberHidden = _config$isMemberHidde === void 0 ? false : _config$isMemberHidde, onSelectorShow = config.onSelectorShow, onSelectorClose = config.onSelectorClose; // TODO 优化下，没必要的中间变量
          contactSelectorEntryConfig = {
            padId: padId,
            isSelectMemberScene: isSelectMemberScene,
            isSelectDeptScene: isSelectDeptScene,
            memberRoleItems: memberRoleItems,
            selectorTitle: selectorTitle,
            selectedDisableItems: selectedDisableItems,
            isMultiSelect: isMultiSelect,
            selectedItems: selectedItems,
            collaborateMemberOption: collaborateMemberOption,
            customizedMemberRoleOption: customizedMemberRoleOption,
            isRootDeptSelected: isRootDeptSelected,
            limitedUnfoldLevelCount: limitedUnfoldLevelCount,
            isMemberHidden: isMemberHidden,
            requestHeaders: requestHeaders,
            onSelectorShow: onSelectorShow
          };
          return _context2.abrupt("return", new Promise( /*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(resolve, reject) {
              var selectorComponentName, extension, selectorComponentConfig;
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    _context.prev = 0;
                    selectorComponentName = mobileMode ? DocsComponentName.CONTACT_SELECTOR_MOBILE : DocsComponentName.CONTACT_SELECTOR;
                    _context.next = 4;
                    return getExtensionSafe(selectorComponentName);
                  case 4:
                    extension = _context.sent;
                    selectorComponentConfig = {
                      onConfirm: function onConfirm(memberList) {
                        resolve(memberList);
                        extension.closeContactSelector();
                      },
                      onClose: function onClose() {
                        onSelectorClose === null || onSelectorClose === void 0 || onSelectorClose();
                        resolve([]);
                        extension.closeContactSelector();
                      },
                      contactSelectorEntryConfig: contactSelectorEntryConfig
                    };
                    extension.showContactSelector(selectorComponentConfig);
                    _context.next = 12;
                    break;
                  case 9:
                    _context.prev = 9;
                    _context.t0 = _context["catch"](0);
                    reject([]);
                  case 12:
                  case "end":
                    return _context.stop();
                }
              }, _callee, null, [[0, 9]]);
            }));
            return function (_x2, _x3) {
              return _ref2.apply(this, arguments);
            };
          }()));
        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function evokeContactSelector(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * @deprecated 唤起 DC 老版好友选择器。该组件历史债务过重请尽量避免使用。已有重写新组件计划，如有需要请联系 zhconghuang or jonahzhou
 * @param options - 好友选择器的配置
 * @returns 组件实例
 */
export var evokeFriendSelector = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(options) {
    var extension, showFriendSelectorContainerProps;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return getExtensionSafe(DocsComponentName.FRIEND_SELECTOR);
        case 2:
          extension = _context3.sent;
          showFriendSelectorContainerProps = options.showFriendSelectorContainerProps;
          showFriendSelectorContainerProps && extension.showFriendSelectorContainer(showFriendSelectorContainerProps);
          return _context3.abrupt("return", extension);
        case 6:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function evokeFriendSelector(_x4) {
    return _ref3.apply(this, arguments);
  };
}();